var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 300,
    viewBox: "0, 0, 400,300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M156.250 92.168 C 132.640 93.394,117.909 96.655,109.398 102.538 C 105.733 105.071,100.542 108.612,97.862 110.408 C 91.307 114.798,91.368 114.842,104.102 114.856 C 128.929 114.884,161.034 120.055,174.727 126.233 C 176.081 126.844,177.497 127.344,177.874 127.344 C 180.328 127.344,206.046 139.115,215.234 144.443 C 238.981 158.215,262.784 178.707,278.863 199.219 C 282.400 203.730,285.570 207.524,285.909 207.650 C 286.247 207.775,289.468 203.802,293.067 198.820 C 296.665 193.838,301.279 187.511,303.320 184.759 C 307.950 178.518,308.032 179.252,301.802 171.206 C 284.940 149.428,259.062 129.092,233.203 117.296 C 230.195 115.924,226.680 114.306,225.391 113.701 L 223.047 112.600 225.391 112.551 C 234.913 112.350,271.988 118.007,279.140 120.751 C 282.671 122.106,271.360 111.198,266.663 108.719 C 245.654 97.628,195.592 90.124,156.250 92.168 ",
    stroke: "none",
    fill: "#353535",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnta);
export default __webpack_public_path__ + "static/media/anta.f27d7e70fe0b441bf5c3e33d5390c53f.svg";
export { ForwardRef as ReactComponent };